<ng-template #tripBookingPackageSummaryTemplate let-bookingPackage="bookingPackage">
  @if (bookingPackage.actual_trip) {
    <div [ngClass]="{'is_return': bookingPackage.actual_trip.type == 'return'}" class="summary trip_packages_trips fx-column">
      @if (bookingPackage.actual_trip.type !== 'return') {
        <div class="trip_package fx-column">
          <div class="label">{{'Pacchetto' | translate}}</div>
          <div class="fx-row fx-justify-space-between fx-items-center">
            <span class="value">{{ bookingPackage.trip_package.description }}</span>
            <span class="value price">{{ bookingPackage.total_amount | currency:"EUR" }}</span>
          </div>
          <!-- show status package -->
          @if (isMixBookingStatus) {
            @if (bookingPackage.booking_status === 'canceled') {
              <div>
                <span class="red-fg">{{'Cancellata' | translate}}</span>
              </div>
            }
            @if (bookingPackage.booking_status === 'confirmed') {
              <div>
                <span class="green-fg">{{'Confermata' | translate}}</span>
              </div>
            }
          }
        </div>
      }
      <div class="fx-column">
        @if (bookingPackage.actual_trip.type !== 'return') {
          <div class="label">{{'Partenza' | translate}}</div>
        }
        <div class="fx-row fx-justify-start fx-items-center" style="gap: 16px">
          @if (bookingPackage.actual_trip.type !== "return") {
            <span class="label">{{ "Andata" | translate }}:</span>
          }
          @if (bookingPackage.actual_trip.type == "return") {
            <span class="label">{{ "Ritorno" | translate }}:</span>
          }
          <div class="value fx-column">
            <span class="value">{{ bookingPackage.actual_trip.display_name }}</span>
            <span class="departure_date_time">
              <span class="start_day">{{ bookingPackage.actual_trip.start_day | date:'dd/MM/yyyy' }} </span>
              @if (bookingPackage.actual_trip.start_time) {
                <span class="start_time">{{ bookingPackage.actual_trip.start_time.substring(0, 5) }}</span>
              }
            </span>
          </div>
        </div>
      </div>
      @if (bookingPackage.trip_booking_resources.length > 0) {
        <div class="fx-column">
          @if (hasOptionalResourcesEnabled[bookingPackage.id]) {
            <div class="label">{{'Opzionale' | translate}}</div>
          }
          <ul style="margin-top: 0;">
            @for (bookingResource of bookingPackage.trip_booking_resources; track bookingResource) {
              @if (bookingResource.optional && bookingResource.activated) {
                <li>
                  <span style="padding-right: 5px;">{{ bookingResource.trip_resource.description }}</span>
                  @if (bookingResource.total_amount) {
                    <span>{{ bookingResource.total_amount | currency:'EUR' }}</span>
                  }
                </li>
              }
            }
          </ul>
        </div>
      }
    </div>
  }
  @if (bookingPackage.target == 'trenitalia') {
    <div class="summary trip_packages_trips">
      <trenitalia-package [inputTripBookingPackage]="bookingPackage"></trenitalia-package>
    </div>
  }
  @if (bookingPackage.target == 'product') {
    <div class="summary trip_packages_trips">
      <product-package [inputTripBookingPackage]="bookingPackage" [mix]="isMixBookingStatus"></product-package>
    </div>
  }
</ng-template>

<div class="trip_booking_summary flex-col justify-start items-start flex-gap-16">
  @if (datasetRS.loading.value) {
    <div class='p-10'>
      <mat-progress-bar style='min-width:300px' mode="indeterminate"></mat-progress-bar>
    </div>
  }
  <div class="entities flex-col flex-gap-8">
    @if (extraParams['channel_value']) {
      <div class="summary fx-column">
        <div class="label">{{'Canale' | translate}}</div>
        <div class="value">{{ extraParams['channel_value'] }}</div>
      </div>
    }
    @if (extraParams['online_order_id']) {
      <div class="summary fx-column">
        <div class="label">{{'Id Ordine Online' | translate}}</div>
        <div class="value">{{ extraParams['online_order_id'] }}</div>
      </div>
    }
    @if (!datasetRS.record.value.ref_id && extraParams['user_name']) {
      <div class="summary fx-column">
        <div class="label">{{'Utente' | translate}}</div>
        <div class="value">{{ extraParams['user_name'] }}</div>
      </div>
    }
    @if (datasetRS.record.value.ref_id) {
      <div class="summary fx-column">
        <div class="label">{{'Rivendita' | translate}}</div>
        <div class="value">Tangerine</div>
      </div>
    }
    @if (datasetRS.record.value.entity && datasetRS.record.value.entity.description) {
      <div class="summary entity fx-column">
        <div class="label">{{'Intestatario' | translate}}</div>
        <div class="value">{{ datasetRS.record.value?.entity?.description }}</div>
      </div>
    }
    @if (datasetRS.record.value.customer && datasetRS.record.value.customer.entity && datasetRS.record.value.customer.entity.description) {
      <div class="summary entity_customer fx-column">
        <div class="label">{{'Cliente' | translate}}</div>
        <div class="value">{{ datasetRS.record.value?.customer?.entity?.description }}</div>
      </div>
    }
    @if (datasetRS.record.value.participant_count > 0) {
      <div class="summary participants fx-column">
        <div class="label">{{'Partecipanti' | translate}}</div>
        <div class="value particiapnts_data">
          @for (participant of datasetRS.record.value.participant_counters | keyvalue; track participant) {
            @if (participant.key !== 'total') {
              <div class="fx-row" style="gap: 6px">
                <div class="label">{{ participant.key }}</div>
                <div class="value">{{ participant.value }}</div>
              </div>
            }
          }
        </div>
      </div>
    }
  </div>
  @for (bookingPackage of datasetRS.record.value.packages; track bookingPackage) {
    <ng-container
      [ngTemplateOutlet]='tripBookingPackageSummaryTemplate'
      [ngTemplateOutletContext]='{bookingPackage:bookingPackage}'
    ></ng-container>
    @if (bookingPackage.children_trip_booking_packages && !['trenitalia'].includes(bookingPackage.target)) {
      @for (childBookingPackage of bookingPackage.children_trip_booking_packages; track childBookingPackage) {
        <ng-container
          [ngTemplateOutlet]='tripBookingPackageSummaryTemplate'
          [ngTemplateOutletContext]='{bookingPackage:childBookingPackage}'
        ></ng-container>
      }
    }
  }
</div>